import Link                from "next/link";
import React, { Fragment } from "react";
import { useTranslation }  from "react-i18next";

import Icon         from "_components/atoms/icon";
import Image        from "_components/atoms/image";
import Loader       from "_components/atoms/loader";
import Typography   from "_components/atoms/typography";
import ListWaypoint from "_components/atoms/waypoint";
import FollowUser   from "_components/molecules/followUser";
import useStyles    from "_styles/organisms/ItemList";

const LikeItem = React.memo ( function LikeItem ( { sportsFanDetails } ) {
	const { classes } = useStyles ( undefined, { name: "styles" } );
	const profileLink = `/profile/${ sportsFanDetails.id }`;

	return (
		<div className = { classes.itemContainer }>
			<div className = { `${ classes.avatarContainer } cursorPointer` }>
				<Link href = { profileLink }
					prefetch  = { false }
				>
					<div className = { classes.avatar }>

						<Image className = { classes.img }
							src             = { sportsFanDetails.photo }
						/>

					</div>
				</Link>
			</div>

			<div className = { classes.itemSectionRightContainer }>
				<div className = { classes.nameTopContainer }>
					<div className = { classes.nameText }>
						<div className = "flex alignItemsCenter noLineHeight cursorPointer">
							<Link href = { profileLink }
								prefetch  = { false }
							>
								<Typography
									className = { `bold ${ classes.nameText }` }
									title     = { sportsFanDetails.name }
									// variant = "body1"
								/>
							</Link>
						</div>
					</div>

					<div className = { classes.followButton }>
						<FollowUser
							followComponent   = { (
								<Icon className = { classes.svgIcon }
									name           = "follower"
								/>
							) }
							isFollowing       = { sportsFanDetails.isFollowing }
							unfollowComponent = { (
								<Icon
									className = { classes.svgIcon }
									name      = "unfollow"
								/>
							) }
							userId            = { sportsFanDetails.id }
							userName          = { sportsFanDetails.name }
						/>
					</div>
				</div>
			</div>
		</div>
	);
} );

const CommentItem = React.memo ( function CommentItem ( { commentMessage, sportsFanDetails, emotesList = [] } ) {
	const { classes } = useStyles ( undefined, { name: "styles" } );
	const profileLink = `/profile/${ sportsFanDetails.id }`;

	const chatEmoteCheck = text => {
		if ( !text )
			return;

		return text.split ( /:/g ).map ( ( elem, i ) => {
			if ( !elem )
				return null;

			if ( !emotesList?.[elem] )
				return elem;

			return (
				<div
					key       = { i }
					className = { classes.emoteContainer }

				>
					<Image
						className = { classes.emotes }
						src       = { emotesList?.[elem] }
					/>
				</div>
			);
		} );
	};

	return (
		<div className = { classes.parent }>
			<div className = { classes.nameAndCommentContainer }>
				<div>
					<a
						className = { classes.anchorTag }
						href      = { profileLink }
						rel       = "noreferrer"
						target    = "_blank"
					>
						<Image
							alt       = ""
							className = { classes.avatarImage }
							src       = { sportsFanDetails.photo }
						/>
					</a>
				</div>

				<div className = { classes.userNameAndCommentInChat }>
					<div className = { classes.userName }>

						<a
							className = { classes.nameAnchorTag }
							href      = { profileLink }
							rel       = "noreferrer"
							target    = "_blank"
						>
							{sportsFanDetails.name}
						</a>

						{":"}
					</div>

					<Typography
						className = { classes.commentText }
						title     = { chatEmoteCheck ( commentMessage ) }
					/>
				</div>
			</div>
		</div>

	);
} );

export default function ItemList ( {
	activeTab,
	dataList,
	isFetching,
	isDepleted,
	pageNo,
	fetchComments,
	fetchLikes,
	emotesList
} ) {
	const { classes }     = useStyles ( undefined, { name: "styles" } );
	const { t }           = useTranslation ();
	const fetchFeedParams = {
		pageNo
	};

	const fetchData = params => {
		if ( activeTab === 0 ) fetchComments ( params );
		else fetchLikes ( params );
	};

	return (
		<div className = { classes.listContainer }>
			{isDepleted && dataList.length === 0 && (
				<div className = { classes.emptyStateContainer }>

					<Image
						className = { classes.chatEmptyIcon }
						src       = "/images/empty-chat.webp"
					/>

					<Typography
						className = "topSpacing"
						color     = "secondary"
						title     = { activeTab === 0 ? "Be the first one to comment" : t ( "reactionbox_no_likes" ) }
						variant   = "label"
					/>
				</div>
			)}

			{isFetching && dataList.length === 0 && <Loader />}

			{dataList.map ( ( item, index ) => (
				<Fragment key = { item.id }>
					{activeTab === 0 ? (
						<CommentItem { ...item }
							emotesList = { emotesList }
						/>
					) : <LikeItem { ...item } />}

					<ListWaypoint
						currentListLength = { dataList.length }
						fetchData         = { fetchData }
						fetchDataParams   = { fetchFeedParams }
						fetchOffset       = { 4 }
						index             = { index }
						isDataDepleted    = { isDepleted }
						isFetchingData    = { isFetching }
					/>
				</Fragment>
			) )}
		</div>
	);
}
